<template>
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10218_14926)">
      <path
        d="M12.945 2.70041L6.78751 9.21791C6.55501 9.46541 6.33001 9.95291 6.28501 10.2904L6.00751 12.7204C5.91001 13.5979 6.54001 14.1979 7.41001 14.0479L9.82501 13.6354C10.1625 13.5754 10.635 13.3279 10.8675 13.0729L17.025 6.55541C18.09 5.43041 18.57 4.14791 16.9125 2.58041C15.2625 1.02791 14.01 1.57541 12.945 2.70041Z"
        stroke="#667085"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9175 3.78711C12.24 5.85711 13.92 7.43961 16.005 7.64961"
        stroke="#667085"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 16.5H18.75"
        stroke="#667085"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10218_14926"
        x="0.5"
        y="0.871094"
        width="23"
        height="24.3789"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10218_14926"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10218_14926"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "EditIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>